// Styles for __name__ go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

const { color, font } = baseVariables;

export const StyledSubMenuContainer = styled.div`
  overflow-y: auto;
`;

export const StyledSubMenu = styled.ul`
  list-style: none;
  padding: ${toRem(24)};
`;

export const StyledSubMenuItem = styled.li`
  padding: ${toRem(10)} 0;
  min-height: ${toRem(48)};
  border-bottom: ${toRem(1)} solid ${color.neutral30};

  a {
    color: ${color.base10};
    font-weight: ${font.fontWeightRegular};
    &:hover {
      font-weight: ${font.fontWeightRegular};
    }
  }
`;
